import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=c52c28cc&scoped=true"
import script from "./MailList.vue?vue&type=script&lang=js"
export * from "./MailList.vue?vue&type=script&lang=js"
import style0 from "./MailList.vue?vue&type=style&index=0&id=c52c28cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52c28cc",
  null
  
)

export default component.exports